import { ReactionActionType } from 'shared_DEPRECATED/components/Reactions/types';
import { updateReactions } from 'shared_DEPRECATED/components/Reactions/utils';

import { ChatInterlocutor } from 'features/chat/config/types/ChatInterlocutor';

import { BaseMessage, Messages, UUID } from '../config/types/Message';

export const updateMessage = <T>(
  prevMessages: T[],
  updateFn: (msg: T) => T | null
): T[] => {
  return prevMessages.map((msg) => {
    const updateResult = updateFn(msg);
    if (updateResult) {
      return { ...msg, ...updateResult };
    }
    return msg;
  });
};

export const updateMessageReactions = ({
  prevMessages,
  messageId,
  reaction,
  action,
  userInfo,
}: {
  prevMessages: Messages;
  messageId: UUID;
  reaction: string;
  action: ReactionActionType;
  userInfo: ChatInterlocutor;
}) => {
  return updateMessage<BaseMessage>(prevMessages, (msg) => {
    if (msg.messageId === messageId) {
      const updatedReactions = updateReactions({
        reactions: msg.reactions,
        emoji: reaction,
        type: action,
        userInfo,
      }) as BaseMessage['reactions'];

      return { ...msg, reactions: updatedReactions };
    }

    return msg;
  });
};
